export default {
  fnNowDate: function() {
    var date = new Date(); // 현재 날짜(로컬 기준) 가져오기
    var utc = date.getTime() + date.getTimezoneOffset() * 60 * 1000; // utc 표준시 도출
    var kstGap = 9 * 60 * 60 * 1000; // 한국 kst 기준시간 더하기
    return new Date(utc + kstGap); // 한국 시간으로 date 객체 만들기(오늘)
  },
  fnNowYear: function() {
    var date = new Date(); // 현재 날짜(로컬 기준) 가져오기
    var utc = date.getTime() + date.getTimezoneOffset() * 60 * 1000; // utc 표준시 도출
    var kstGap = 9 * 60 * 60 * 1000; // 한국 kst 기준시간 더하기
    return this.fnPrintOnlyYear(new Date(utc + kstGap)); // 한국 시간으로 date 객체 만들기(오늘)
  },
  fnPrintDate: function(_date) {
    let _month = _date.getMonth();
    _month = "0" + (_month + 1);
    let _day = "0" + _date.getDate();
    return _date.getFullYear() + "-" + _month.substring(_month.length - 2, _month.length) + "-" + _day.substring(_day.length - 2, _day.length);
  },
  fnPrintDate2: function(_date) {
    let _month = _date.getMonth();
    _month = "0" + (_month + 1);
    let _day = "0" + _date.getDate();
    return _date.getFullYear() + _month.substring(_month.length - 2, _month.length) + _day.substring(_day.length - 2, _day.length);
  },
  fnToday: function(exp) {
    var date = new Date(); // 현재 날짜(로컬 기준) 가져오기
    var utc = date.getTime() + date.getTimezoneOffset() * 60 * 1000; // utc 표준시 도출
    var kstGap = 9 * 60 * 60 * 1000; // 한국 kst 기준시간 더하기
    var today = new Date(utc + kstGap); // 한국 시간으로 date 객체 만들기(오늘)

    let _month = today.getMonth();
    _month = "0" + (_month + 1);
    let _day = "0" + today.getDate();

    if (exp == null) {
      return today.getFullYear() + "-" + _month.substring(_month.length - 2, _month.length) + "-" + _day.substring(_day.length - 2, _day.length);
    } else {
      return today.getFullYear() + exp + _month.substring(_month.length - 2, _month.length) + exp + _day.substring(_day.length - 2, _day.length);
    }

    return today.getFullYear() + "-" + _month.substring(_month.length - 2, _month.length) + "-" + _day.substring(_day.length - 2, _day.length);
  },
  fnPrintMonth: function(_date) {
    let _month = _date.getMonth();
    _month = "0" + (_month + 1);
    return _date.getFullYear() + "-" + _month.substring(_month.length - 2, _month.length);
  },
  fnPrintOnlyYear: function(_date) {
    return _date.getFullYear();
  },
  fnPrintOnlyMonth: function(_date) {
    let _month = _date.getMonth();
    return _month + 1;
  },
  fnPrintOnlyMonthStr: function(_date) {
    let _month = _date.getMonth() + 1;
    return _month < 10 ? "0" + _month : _month;
  },
  fnPrintDateByNum: function(_date) {
    if (_date != null && _date != "") {
      let year = _date.substring(0, 4);
      let month = _date.substring(4, 6);
      let day = _date.substring(6, 8);
      return year + "-" + month + "-" + day;
    }
    return "";
  },
  fnConvertStrDate: function(str, exp) {
    let year;
    let month;
    let day;
    if (exp == null) {
      year = str.substring(0, 4);
      month = str.substring(4, 6);
      day = str.substring(6, 8);
    } else {
      str = str.split(exp);
      year = str[0];
      month = str[1];
      day = str[2];
    }
    return new Date(year, month, day);
  },
  fnConvertDateStr: function(paramDate, exp) {
    let _date = new Date(paramDate);
    let month = _date.getMonth() + 1;
    let day = _date.getDate();
    let year = _date.getFullYear();
    let _month = month < 10 ? "0" + month : month;
    let _day = day < 10 ? "0" + day : day;
    if (exp == null) {
      return year + "/" + _month + "/" + _day;
    } else {
      return year + exp + _month + exp + _day;
    }
  },
  fnOnFileDownload: function(seq) {
    window.location = "/file/download/" + seq;
  },
  fnConvertDateTimeStr: function(_date, exp) {
    if (_date == null) {
      return "";
    }
    let dt = new Date(_date);
    let month = dt.getMonth() + 1;
    let day = dt.getDate();
    let year = dt.getFullYear();
    let hh = dt.getHours();
    let min = dt.getMinutes();
    let ss = dt.getSeconds();
    day = day < 10 ? "0" + day : day;
    hh = hh < 10 ? "0" + hh : hh;
    min = min < 10 ? "0" + min : min;
    ss = ss < 10 ? "0" + ss : ss;
    let _month = month < 10 ? "0" + month : month;
    if (exp == null) {
      return year + "/" + _month + "/" + day + " " + hh + ":" + min + ":" + ss;
    } else {
      return year + exp + _month + exp + day + " " + hh + ":" + min + ":" + ss;
    }
  },
  numberWithCommas: function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  /**
   *
   * @param {*} data
   * @param {소수점 자릿수} number
   */
  addCommaDecimalPoint: function(data, number) {
    if (data == 0 || data == null) return "";

    data = data.toString();
    data = data.replace(/,/g, "");

    if (number == 0 || arguments.length == 1) {
      //원단위 절사
      data = Math.floor(data);
    }

    let forData = Number(data);
    if (arguments.length == 2) {
      forData = Number(data).toFixed(number);
    }
    let formattedNumber = forData.toString();
    // 소수점 이하가 0으로 끝날 경우 소수점과 이후의 0 제거
    if (formattedNumber.includes(".")) {
      formattedNumber = formattedNumber.replace(/\.?0+$/, "");
    }
    formattedNumber = this.numberWithCommas(formattedNumber);

    return formattedNumber;
  },
  fnNowMonth: function() {
    var date = new Date(); // 현재 날짜(로컬 기준) 가져오기
    var utc = date.getTime() + date.getTimezoneOffset() * 60 * 1000; // utc 표준시 도출
    var kstGap = 9 * 60 * 60 * 1000; // 한국 kst 기준시간 더하기
    var today = new Date(utc + kstGap); // 한국 시간으로 date 객체 만들기(오늘)

    let _month = today.getMonth();
    _month = "0" + (_month + 1);
    let _day = "0" + today.getDate();
    return today.getFullYear() + "-" + _month.substring(_month.length - 2, _month.length);
  },
  openPop(id) {
    let newID = $("#" + id);
    newID.modal("show");
    newID.removeAttr("inert");
    newID.attr("aria-hidden", "false");
  },
  closePop(id) {
    let newID = $("#" + id);
    newID.attr("inert", "");
    newID.attr("aria-hidden", "true");
    document.activeElement.blur();
    $(newID).modal("hide");
  },
  getLastDayOfMonth: function(year, month) {
    return new Date(year, month, 0).getDate();
  },
  ezConfirm: function(tit, firstBtnNm, secondBtnNm, callBack, param) {
    Swal.fire({
      title: tit,
      //text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: firstBtnNm,
      cancelButtonText: secondBtnNm
    }).then(result => {
      if (!result.isConfirmed) return false;

      if (arguments.length == 5) {
        callBack(param);
      } else {
        callBack();
      }
    });
  },
  /**
   * 디자인하우스 재무팀
   */
  dhAdministerChk(accType) {
    if (accType == "ACC_0003" || accType == "ACC_0000") {
      return true;
    } else {
      return false;
    }
  },
  uzConfirm: function(tit, firstBtnNm, secondBtnNm, callBack, param) {
    Swal.fire({
      title: tit,
      //text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: firstBtnNm,
      cancelButtonText: secondBtnNm
    }).then(result => {
      if (!result.isConfirmed) return false;

      if (arguments.length == 5) {
        callBack(param);
      } else {
        callBack();
      }
    });
  },
  getManagerFlag: function(userID, dprtmMngId) {
    if (userID != "2036" && dprtmMngId != "1200" && dprtmMngId != "1300") {
      return true;
    }
    return false;
  },
  addLeadingZero(number, length) {
    var str = number.toString();
    while (str.length < length) {
      str = "0" + str;
    }
    return str;
  },
  ezDatepicker: function(opt) {
    let opt1 = {
      autoclose: true,
      format: "yyyy-mm-dd",
      todayHighlight: true,
      titleFormat: "yyyy MM",
      showOtherMonths: false,
      maxDate: "",
      minDate: "",
      changeYear: false,
      changeMonth: false
    };

    let object = $.extend({}, opt1, opt);

    $(opt.id).datepicker({
      autoclose: object.autoclose,
      format: object.format,
      todayHighlight: object.todayHighlight,
      titleFormat: object.titleFormat,
      showOtherMonths: object.showOtherMonths,
      maxDate: object.maxDate,
      minDate: object.minDate,
      changeYear: object.changeYear,
      changeMonth: object.changeMonth
    });
  },
  ezStartEndDatepicker: function(opt) {
    let ezThis = this;
    let opt1 = {
      autoclose: true,
      format: "yyyy-mm-dd",
      todayHighlight: true,
      titleFormat: "yyyy MM",
      showOtherMonths: false,
      minDate: "",
      maxDate: "",
      changeYear: false,
      changeMonth: false
    };

    let object = $.extend({}, opt1, opt);

    $(opt.startDate).datepicker({
      autoclose: object.autoclose,
      format: object.format,
      todayHighlight: object.todayHighlight,
      titleFormat: object.titleFormat,
      showOtherMonths: object.showOtherMonths,
      maxDate: object.maxDate,
      minDate: object.minDate,
      changeYear: object.changeYear,
      changeMonth: object.changeMonth
    });

    $(opt.endDate).datepicker({
      autoclose: object.autoclose,
      format: object.format,
      todayHighlight: object.todayHighlight,
      titleFormat: object.titleFormat,
      showOtherMonths: object.showOtherMonths,
      maxDate: object.maxDate,
      minDate: object.minDate,
      changeYear: object.changeYear,
      changeMonth: object.changeMonth
    });

    $(opt.endDate).datepicker("option", "minDate", $(opt.startDate).val());
    $(opt.startDate).datepicker("option", "onClose", function(selectedDate) {
      let data = ezThis.getAddDay(selectedDate, 1);
      $(opt.endDate).datepicker("option", "minDate", data);
    });
    $(opt.endDate).datepicker("option", "onClose", function(selectedDate) {
      $(opt.startDate).datepicker("option", "maxDate", selectedDate);
    });
  },
  getAddDay: function(sDate, nDays) {
    let yy = parseInt(sDate.substr(0, 4), 10);
    let mm = parseInt(sDate.substr(5, 2), 10);
    let dd = parseInt(sDate.substr(8), 10);

    let day = new Date(yy, mm - 1, dd + nDays);

    yy = day.getFullYear();
    mm = day.getMonth() + 1;
    mm = mm < 10 ? "0" + mm : mm;
    dd = day.getDate();
    dd = dd < 10 ? "0" + dd : dd;
    return yy + "-" + mm + "-" + dd;
  },
  getAddMinusDay: function(sDate, nDays) {
    const date = new Date(sDate);
    if (this.isNullOrUndefined(nDays)) {
      nDays = 7;
    }
    date.setDate(date.getDate() - nDays);
    return date.toISOString().split("T")[0];
  },
  getDateDiff: function(d1, d2) {
    let date1 = new Date(d1);
    let date2 = new Date(d2);

    let diffDate = date1.getTime() - date2.getTime();

    return Math.abs(diffDate / (1000 * 60 * 60 * 24));
  },
  formatDate: function(str, format) {
    let returnData = "";
    if (arguments.length == 1) format = "-";

    if (str.length == 6) {
      returnData = str.substring(0, 4) + format + str.substring(4);
    } else if (str.length == 8) {
      returnData = str.substring(0, 4) + format + str.substring(4, 6) + format + str.substring(6);
    } else {
      returnData = str;
    }
    return returnData;
  },
  isNullOrUndefined(value) {
    return (
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim() === "") || // 문자열일 때만 trim 적용
      (typeof value === "number" && isNaN(value)) // 숫자일 때 NaN 확인
    );
  },
  getToday: function(format) {
    let data = "";
    let now = new Date();
    let year = now.getFullYear().toString(); // 문자열로 변환
    let month = (now.getMonth() + 1).toString().padStart(2, "0");
    let date = now
      .getDate()
      .toString()
      .padStart(2, "0");
    let hours = now
      .getHours()
      .toString()
      .padStart(2, "0");
    let min = now
      .getMinutes()
      .toString()
      .padStart(2, "0");
    let sec = now
      .getSeconds()
      .toString()
      .padStart(2, "0");

    switch (format) {
      case "YYYYMMDD":
        data = year + month + date;
        break;
      case "YYYY":
        data = year;
        break;
      case "YYYY-MM":
        data = year + "-" + month;
        break;
      case "YYYY-MM-DD":
        data = year + "-" + month + "-" + date;
        break;
      case "YYYY.MM.DD":
        data = year + "." + month + "." + date;
        break;
      case "YYYYMMDDHHmmss":
        data = year + "." + month + "." + date + hours + min + sec;
        break;
      case "YYYYMMDDHHmm":
        data = year + "." + month + "." + date + hours + min;
        break;
      case "YYYYMMDDHHmmssA":
        data = year + month + date + hours + min + sec;
        break;
      default:
        data = year + month + date;
        break;
    }
    return data;
  },
  addHyphenPhoneNumber: function(phoneNumber) {
    if (phoneNumber == undefined || phoneNumber == null) return "";
    let length = phoneNumber.length;
    if (length >= 9) {
      let numbers = phoneNumber.replace(/[^0-9]/g, "").replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
      return numbers;
    } else {
      return phoneNumber;
    }
  },
  uzValidation: function(formId) {
    let flag = true;

    $("#" + formId)
      .find("input, select, radio, textarea")
      .each(function(index) {
        let elementType = $(this)
          .prop("tagName")
          .toLowerCase();
        let valid = $(this).attr("valid");
        if (!$(this).is(":hidden") && valid == undefined) {
          if (elementType === "input") {
            let inputType = $(this).attr("type");
            let nm = $(this).attr("name");
            if (inputType === "text" || inputType === "password" || inputType === "radio") {
              if ($.isEmptyObject($(this).val()) || $(this).val() == 0) {
                let alertMsg = $(this).attr("alertMsg");
                if (!$.isEmptyObject(alertMsg)) {
                  Swal.fire(alertMsg);
                  flag = false;
                  return false;
                } else {
                  let msg = $(this).prop("placeholder");
                  if (!$.isEmptyObject(msg)) {
                    Swal.fire(msg + "을 입력해주세요.");
                    flag = false;
                    return false;
                  }
                }
              }
            }
          } else if (elementType === "select") {
            let id = $(this).prop("id");

            if ($.isEmptyObject($(this).val())) {
              if (!$.isEmptyObject(id) && $.isEmptyObject($("#" + id).val())) {
                let alertMsg = $(this).attr("alertMsg");
                Swal.fire(alertMsg);
                flag = false;
                return false;
              }
            }
          }
        }
      });

    return flag;
  },
  getHost: function() {
    return location.protocol + "//" + window.location.host + "/";
  },
  isMobile: function() {
    let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) {
      isMobile = /Mobi/i.test(window.navigator.userAgent);
    }

    return isMobile;
  },
  vatOption() {
    // :value="item.m_type_nm" :sys_code="item.m_type"
    let optionList = [
      { value: "17", sys_code: " 카드매출" },
      { value: "26", sys_code: " 의제매입세액" },
      { value: "19", sys_code: " 면세건별" },
      { value: "21", sys_code: " 과세매입" },
      { value: "22", sys_code: " 영세매입" },
      { value: "23", sys_code: " 면세매입" },
      { value: "24", sys_code: " 매입불공제" },
      { value: "25", sys_code: " 수입" },
      { value: "27", sys_code: " 카드매입" },
      { value: "28", sys_code: " 현금영수증매입" },
      { value: "29", sys_code: " 과세매입" },
      { value: "31", sys_code: " 현금과세" },
      { value: "32", sys_code: " 현금면세" },
      { value: "33", sys_code: " 과세매출" },
      { value: "34", sys_code: " 카드영세" },
      { value: "35", sys_code: " 현금영세" },
      { value: "36", sys_code: " 기타영세" },
      { value: "41", sys_code: " 카드기타" },
      { value: "15", sys_code: " 종합매출" },
      { value: "12", sys_code: " 영세매출" },
      { value: "11", sys_code: " 과세매출" },
      { value: "13", sys_code: " 면세매출" },
      { value: "14", sys_code: " 건별매출" },
      { value: "16", sys_code: " 수출" },
      { value: "18", sys_code: " 면세카드매출" }
    ];
    return optionList;
  },

  ioneContractOpitionList() {
    let optionList = [
      { label: "마감년도", checked: true },
      { label: "마감월", checked: true },
      { label: "대구분", checked: true },
      { label: "중구분", checked: true },
      { label: "모듈", checked: true },
      { label: "프로그램", checked: true },
      { label: "체결여부", checked: true },
      { label: "정산채널", checked: true },
      { label: "담당자(아이원)", checked: true },
      { label: "거래처", checked: true },
      { label: "NSM사업자번호", checked: true },
      { label: "분할청구", checked: true },
      { label: "계약기간", checked: true },
      { label: "만료년", checked: true },
      { label: "만료월", checked: true },
      { label: "업무내역", checked: true },
      { label: "담당자", checked: true },
      { label: "TEL", checked: true },
      { label: "FAX", checked: true },
      { label: "담당자이메일", checked: true },
      { label: "키락개수", checked: true },
      { label: "P/G", checked: true },
      { label: "멤버쉽금액", checked: true },
      { label: "입금공급가", checked: true },
      { label: "실질멤머쉽금액", checked: true },
      { label: "NSM승인연도​", checked: true },
      { label: "NSM승인월​", checked: true },
      { label: "NSM공급가​", checked: true },
      { label: "더존마진​", checked: true },
      { label: "아이원매출​", checked: true },
      { label: "순수기타매출​", checked: true },
      { label: "당초기타매출​", checked: true },
      { label: "UMS발주금액​", checked: true },
      { label: "APO수주월​", checked: true },
      { label: "APO수주액​", checked: true },
      { label: "특이사항", checked: true },
      { label: "비대면여부​", checked: true },
      { label: "클라우드지원사업여부​", checked: true },
      { label: "업종​​", checked: true },
      { label: "iCUBE사업자번호​​", checked: true },
      { label: "주문년도​​", checked: true },
      { label: "주문월​​", checked: true },
      { label: "iCUBE주문번호​​", checked: true },
      { label: "iCUBE 매출마감번호​", checked: true },
      { label: "참조코드​​", checked: true }
    ];
    return optionList;
  },
  isValidDateRange(startDateStr, endDateStr) {
    const start = new Date(startDateStr);
    const end = new Date(endDateStr);

    // 앞의 날짜가 뒤의 날짜보다 이후면 안됨
    if (start > end) {
      return {
        valid: false,
        reason: "시작일은 종료일보다 이후일 수 없습니다."
      };
    }

    // 날짜 차이 계산 (일 단위)
    const diffInMs = end - start;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    if (diffInDays > 30) {
      return {
        valid: false,
        reason: "날짜 범위는 최대 30일 이내여야 합니다."
      };
    }

    return {
      valid: true
    };
  },
  cancelConfirm: function(tit, firstBtnNm, secondBtnNm, callBack, param, cancelCallBack, cancelParam) {
    Swal.fire({
      title: tit,
      //text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: firstBtnNm,
      cancelButtonText: secondBtnNm
    }).then(result => {
      if (!result.isConfirmed){
        cancelCallBack(cancelParam);
        return;
      }
      if (arguments.length == 5) {
        callBack(param);
      } else {
        callBack();
      }
    });
  },
  dateRange: function(start_date, end_date) {
    const start = new Date(start_date);
    const end = new Date(end_date);
    return start <= end;
  }
};



// WEBPACK FOOTER //
// ./src/components/common.js